










































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue';
import { saveAs } from 'file-saver';
import cloneDeep from 'lodash/cloneDeep';
import colors from 'vuetify/lib/util/colors';
import Convert from '@/classes/convert';
import SaveDataView from '@/components/saveData/SaveDataView.vue';
import SaveDataTab from '@/components/saveData/SaveDataTab.vue';
import SaveDataMobileTab from '@/components/saveData/SaveDataMobileTab.vue';
import ShareDialog from '@/components/saveData/ShareDialog.vue';
import UploadSaveData from '@/components/saveData/UploadSaveData.vue';
import SettingInitialLevel from '@/components/item/SettingInitialLevel.vue';
import ShipImportDiff from '@/components/database/ShipImportDiff.vue';
import SaveData from '@/classes/saveData/saveData';
import SiteSetting, { SiteTheme } from '@/classes/siteSetting';
import FirebaseManager from '@/classes/firebaseManager';
import LZString from 'lz-string';
import ShipStock from './classes/fleet/shipStock';
import ItemStock from './classes/item/itemStock';
import Fleet from './classes/fleet/fleet';
import CalcManager from './classes/calcManager';
import FleetInfo from './classes/fleet/fleetInfo';
import Const, { AB_MODE } from './classes/const';
import ShipStockDiff from './classes/fleet/shipStockDiff';
import Airbase from './classes/airbase/airbase';
import AirbaseInfo from './classes/airbase/airbaseInfo';

/** バックアップ通知の間隔 (1ヵ月) */
const BACKUP_PROMPT_INTERVAL = 1000 * 60 * 60 * 24 * 30;

export default Vue.extend({
  name: 'App',
  components: {
    SaveDataView,
    SaveDataTab,
    ShareDialog,
    ShipImportDiff,
    SettingInitialLevel,
    UploadSaveData,
    SaveDataMobileTab,
  },
  data: () => ({
    saveData: new SaveData(),
    mainSaveData: new SaveData(),
    drawer: false,
    configDialog: false,
    loading: true,
    somethingText: '',
    textareaHasError: false,
    readState: false as boolean | string,
    readInform: false,
    readInformText: '',
    readResultColor: 'success',
    setting: new SiteSetting(),
    editDialog: false,
    editedName: '',
    editedRemarks: '',
    isDirectory: false,
    selectedColor: '',
    saveDataOrder: 0,
    shareDialog: false,
    urlParameters: {} as { data?: string; predeck?: string; stockid?: string },
    urlFragments: {} as { predeck?: string; ships?: ShipStock[]; items?: ItemStock[]; saveData?: string },
    unsubscribe: undefined as unknown,
    rules: {
      simulationCountRange: (value: number) => !(value < 100 || value > 100000) || '100 ～ 100000で指定してください。',
      popUpRange: (value: number) => !(value < 10 || value > 10000) || '10 ～ 10000で指定してください。',
    },
    readOnlyMode: false,
    disabledUpload: true,
    saveDialogTab: 'save',
    enabledFixDrawer: false,
    backupString: undefined as undefined | string,
    fileValue: undefined as File | undefined,
    backupSelectDialog: false,
    backupPromptDialog: false,
    backupPromptChecked: false,
    isImportSaveData: true,
    isImportShipData: true,
    isImportItemData: true,
    isImportURLData: true,
    disabledIndexedDB: false,
    fleetSelectDialog: false,
    selectableFleets: [] as { selected: boolean; fleet: Fleet; supportTypeName: string }[],
    tempManager: undefined as undefined | CalcManager,
    fileColors: Const.FILE_COLORS,
    areaOverwriteConfirmDialog: false,
    readyImportShipStock: [] as ShipStock[],
    shipStockDiffDialog: false,
    isMobile: true,
    mobileTabDialog: false,
  }),
  computed: {
    getCompletedAll() {
      return this.$store.getters.getCompletedAll;
    },
    isTempStockMode(): boolean {
      // 一時所持情報データがあるなら
      return this.$store.getters.getExistsTempStock;
    },
    getTextareaColor() {
      return this.somethingText && this.textareaHasError ? 'red darken-4' : 'primary';
    },
    enabledUndo(): boolean {
      const data = this.mainSaveData;
      return data ? data.tempIndex > 0 : false;
    },
    enabledRedo(): boolean {
      const data = this.mainSaveData;
      return data ? data.tempIndex < data.tempData.length - 1 : false;
    },
    isNameEmpty(): boolean {
      return this.editedName.length <= 0;
    },
    isManagerPage(): boolean {
      return this.$route.path.endsWith('/manager');
    },
    isAirCalcPage(): boolean {
      return this.$route.path.endsWith('/aircalc');
    },
    isExtraPage(): boolean {
      return this.$route.path.endsWith('/extra');
    },
    isLight(): boolean {
      return this.setting.themeDetail === 'light';
    },
    isIce(): boolean {
      return this.setting.themeDetail === 'ice';
    },
    isPink(): boolean {
      return this.setting.themeDetail === 'pink';
    },
    isGreen(): boolean {
      return this.setting.themeDetail === 'green';
    },
    isDark(): boolean {
      return this.setting.themeDetail === 'dark';
    },
    isDeepSea(): boolean {
      return this.setting.themeDetail === 'deep-sea';
    },
    hasItemUIBorder(): boolean {
      return this.setting.itemUI.border;
    },
    isItemUIBold(): boolean {
      return this.setting.itemUI.bold;
    },
    isItemUIRadius(): boolean {
      return this.setting.itemUI.radius;
    },
    showSideBtn(): boolean {
      return this.isAirCalcPage && this.setting.visibleAirCalcMenuButton && !this.isMobile;
    },
    drawerFixed(): boolean {
      return this.enabledFixDrawer && this.setting.fixedDrawer;
    },
    routerViewClass(): string {
      if (this.isMobile) {
        return 'px-2 pt-6';
      }

      if (this.setting.visibleAirCalcMenuButton && this.isAirCalcPage) return 'pl-4 pr-12';
      return 'px-4';
    },
    selectedAnyFleet(): boolean {
      return this.selectableFleets.some((v) => v.selected);
    },
    isJapanese(): boolean {
      return this.setting.locale === 'ja';
    },
    isEnglish(): boolean {
      return this.setting.locale === 'en';
    },
    isChinese(): boolean {
      return this.setting.locale === 'cn';
    },
    needTrans(): boolean {
      return !this.isJapanese && !this.setting.nameIsNotTranslate;
    },
    getShipStockDiff(): ShipStockDiff {
      return this.$store.getters.getShipStockDiff;
    },
    tabCount(): number {
      if (!this.isMobile) {
        return 0;
      }
      return this.saveData.fetchActiveData().length;
    },
  },
  watch: {
    getCompletedAll(value) {
      if (value) {
        this.loadURLInformation();
        if (!this.backupPromptChecked) {
          this.backupPromptChecked = true;
          this.$nextTick(() => {
            this.checkAutoBackupPrompt();
          });
        }
      }

      if (!this.urlParameters || !this.urlParameters.stockid) {
        this.loading = !value;
      }
      this.disabledIndexedDB = this.$store.state.disabledDatabase;
    },
    isTempStockMode(value) {
      this.readOnlyMode = !!value;
    },
    editDialog(value) {
      if (value) {
        setTimeout(() => {
          (this.$refs.saveDataNameInput as HTMLInputElement).focus();
        }, 150);
      }
    },
    getShipStockDiff(value: ShipStockDiff) {
      if (value.diffs.length || value.newcomers.length || value.expulsionShips.length) {
        this.updateIsMobile();
        this.shipStockDiffDialog = true;
      }
    },
  },
  created() {
    this.setting = this.$store.state.siteSetting as SiteSetting;
    this.saveData = this.$store.state.saveData as SaveData;
    // セーブデータの更新を購読
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'updateSaveData') {
        // 計算処理更新の購読 常に最新の状態を保つ
        this.saveData = state.saveData as SaveData;
      } else if (mutation.type === 'setMainSaveData') {
        // メインデータの更新を購読 常に最新の状態を保つ
        this.mainSaveData = state.mainSaveData as SaveData;
      } else if (mutation.type === 'updateSetting') {
        // 設定情報の更新を購読 常に最新の状態を保つ
        this.setting = state.siteSetting as SiteSetting;
        if (this.setting.themeDetail) {
          this.changeSiteTheme(this.setting.themeDetail);
        } else {
          // 基本のテーマ2種
          this.changeSiteTheme('dark');
        }

        if (this.setting.locale) {
          this.changeLocale(this.setting.locale);
        }

        if (!this.setting.fixedDrawer) {
          this.drawer = false;
        }
        this.onResize();
      }
    });

    // URLパラメータ or fragments取得 & 一時退避 => マスタ読み込み完了後に処理
    const { search, hash } = document.location;
    if (search || hash) {
      this.getUrlParams(search);
      this.setUrlFragments(hash);
      if (!this.loading) {
        this.loadURLInformation();
      }
    }
  },
  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const w = window as any;
    w.loadShipData = this.setShipStock;
    w.loadItemData = this.setItemStock;
    w.loadDeckBuilder = this.loadAndOpenFromDeckBuilder;
    // const stock = Convert.restoreTest('');
    // console.log(ShipStock.createFleetAnalyticsCode(stock));
    // const itemStock = Convert.restoreItemTest('');
    // console.log(ItemStock.createFleetAnalyticsCode(itemStock));

    document.addEventListener('keyup', this.keyupHandler);
    document.addEventListener('keydown', this.keydownHandler);
    this.$nextTick(() => {
      this.updateIsMobile();
    });
  },
  methods: {
    updateIsMobile() {
      this.isMobile = window.innerWidth < 600;
    },
    textFieldFocused(focusEvent: FocusEvent) {
      if (focusEvent) (focusEvent.target as HTMLInputElement).select();
    },
    pushPage(path: string) {
      if (this.mobileTabDialog) {
        this.mobileTabDialog = false;
      }
      if (this.$route.path !== path) this.$router.push({ path });
    },
    showSiteSetting() {
      this.updateIsMobile();
      this.configDialog = true;
    },
    openBackupPrompt() {
      this.backupPromptDialog = true;
    },
    hasAnyBackupSaveData(saveData: SaveData): boolean {
      if (!saveData.isDirectory) {
        return true;
      }
      return saveData.childItems.some((v) => this.hasAnyBackupSaveData(v));
    },
    hasBackupPromptTargetData(): boolean {
      const hasSaveData = this.hasAnyBackupSaveData(this.saveData);
      const hasShipStock = (this.$store.state.shipStock as ShipStock[]).length > 0;
      const hasItemStock = (this.$store.state.itemStock as ItemStock[]).length > 0;
      const hasOutputHistories = this.$store.state.outputHistories.length > 0;
      return hasSaveData || hasShipStock || hasItemStock || hasOutputHistories;
    },
    checkAutoBackupPrompt() {
      if (this.backupPromptDialog || !this.hasBackupPromptTargetData()) {
        return;
      }

      const lastActionAt = Math.max(this.setting.lastBackupCreatedAt ?? 0, this.setting.lastBackupPromptAt ?? 0);
      if (!lastActionAt || Date.now() - lastActionAt >= BACKUP_PROMPT_INTERVAL) {
        this.openBackupPrompt();
      }
    },
    skipBackupPrompt() {
      this.setting.lastBackupPromptAt = Date.now();
      this.$store.dispatch('updateSetting', this.setting);
      this.backupPromptDialog = false;
    },
    backupNowFromPrompt() {
      this.downloadBackupFile();
      this.backupPromptDialog = false;
    },
    async loadURLInformation() {
      // 展開待ち中のデータがあれば読み込んで消す
      if (Object.keys(this.urlParameters).length) {
        if (this.urlParameters.data) {
          // 編成データ解析
          const urlData = SaveData.decodeURLSaveData(this.urlParameters.data);
          urlData.isMain = true;
          urlData.isActive = true;
          this.saveData.childItems.push(urlData);
          this.$store.dispatch('setMainSaveData', urlData);
          if (!this.isAirCalcPage) {
            // ページ遷移
            this.$router.push('aircalc');
          }
        } else if (this.urlParameters.predeck && this.loadAndOpenFromDeckBuilder(this.urlParameters.predeck)) {
          // デッキビルダー解析
          this.inform('編成の読み込みが完了しました。');
        } else if (this.urlParameters.stockid) {
          this.$store.dispatch('updateReadStockId', this.urlParameters.stockid);

          // 所持情報データ解析
          const stockData = await FirebaseManager.getAndRestoreStockData(this.urlParameters.stockid);

          // 一時所持情報にセットして管理ページを展開
          let available = false;
          if (stockData.shipStocks.length) {
            this.$store.dispatch('updateTempShipStock', stockData.shipStocks);
            available = true;
          }
          if (stockData.itemStocks.length) {
            this.$store.dispatch('updateTempItemStock', stockData.itemStocks);
            available = true;
          }
          if (available && stockData.date) {
            this.$store.dispatch('updateTempDate', stockData.date);
          }

          if (available) {
            if (!this.$route.path.endsWith('/manager')) {
              // ページ遷移
              this.$router.push('manager');
            }
          } else {
            this.inform('所持情報の読み取りに失敗しました。', true);
          }

          this.loading = false;
        }
        // 処理完了後除去
        this.urlParameters = {};
      } else if (Object.keys(this.urlFragments).length) {
        const informText: string[] = [];
        if (this.urlFragments.ships && this.urlFragments.ships.length) {
          const data = this.urlFragments.ships;
          // 艦隊反映
          this.setting.isStockOnlyForShipList = true;
          this.$store.dispatch('updateSetting', this.setting);

          const shipStock = this.$store.state.shipStock as ShipStock[];
          // 旧版かどうかチェック => uniqueIdが仕事しているなら札置き換え判定が出せる (今までは連番を振ってきたので、ユニークidの最大と登録隻数が一致しているかで判定できる)
          if (shipStock.length && shipStock[shipStock.length - 1].uniqueId !== shipStock.length && data[data.length - 1].uniqueId !== data.length) {
            // 札の置き換えが発生しそうか？
            if (data.some((w) => shipStock.find((v) => v.uniqueId === w.uniqueId && v.area !== w.area))) {
              // 札が置き換わりそうじゃ。
              this.areaOverwriteConfirmDialog = true;
              this.readyImportShipStock = data;
            } else {
              informText.push('在籍艦娘の更新');
              this.$store.dispatch('updateShipStock', data);
            }
          } else {
            informText.push('在籍艦娘の更新');
            this.$store.dispatch('updateShipStock', data);
          }
        }
        if (this.urlFragments.items && this.urlFragments.items.length) {
          // 装備反映
          informText.push('所持装備の更新');
          this.setting.isStockOnlyForItemList = true;
          this.$store.dispatch('updateSetting', this.setting);
          this.$store.dispatch('updateItemStock', this.urlFragments.items);
        }
        if (this.urlFragments.predeck && this.loadAndOpenFromDeckBuilder(this.urlFragments.predeck)) {
          informText.push('編成の読み込み');
        } else if (this.urlFragments.saveData) {
          const urlData = SaveData.decodeURLSaveData(this.urlFragments.saveData);
          urlData.isMain = true;
          urlData.isActive = true;
          this.saveData.childItems.push(urlData);
          this.$store.dispatch('setMainSaveData', urlData);
          if (!this.isAirCalcPage) {
            // ページ遷移
            this.$router.push('aircalc');
          }
          informText.push('編成の読み込み');
        }
        if (informText.length) {
          this.inform('URL fragmentsよりデータを読み込みました。');
        }
        // 処理完了後除去
        this.urlFragments = {};
      }
    },
    readSomethingText() {
      if (!this.somethingText) {
        return;
      }
      this.readState = 'primary';
      // デッキビルダー形式データ読み込み試行
      if (this.loadAndConfirmDeckBuilder(this.somethingText)) {
        this.inform('デッキビルダー形式編成データを読み込みました。');
      } else if (this.setShipStock(this.somethingText)) {
        if (this.areaOverwriteConfirmDialog) {
          this.somethingText = '';
          this.readState = false;
          return;
        }
        // 在籍艦娘データ読み込み試行
        this.inform('在籍艦娘データの更新が完了しました。');
      } else if (this.setItemStock(this.somethingText)) {
        // 所持装備データ読み込み試行
        this.inform('所持装備データの更新が完了しました。');
      } else {
        // 全部失敗
        this.inform('データの読み込みに失敗しました。正しいデータではない可能性があります。', true);
      }

      // 後始末と通知
      this.somethingText = '';
      this.readState = false;
    },
    loadAndConfirmDeckBuilder(builder: string): boolean {
      const text = builder.indexOf('predeck=') >= 0 ? builder.split('predeck=')[1] : builder;
      if (this.setting.importAllDeck) {
        return this.loadAndOpenFromDeckBuilder(text);
      }
      try {
        const { items, ships, cellInfos } = this.$store.state;
        const converter = new Convert(items, ships, this.$store.getters.getEnemies, cellInfos);
        const manager = converter.loadDeckBuilder(text);
        if (!manager) {
          // 何もない編成データは無意味なので返す
          return false;
        }

        this.selectableFleets = [];
        for (let i = 0; i < manager.fleetInfo.fleets.length; i += 1) {
          const fleet = manager.fleetInfo.fleets[i];
          if (fleet.ships.some((v) => v.data.id > 0)) {
            this.selectableFleets.push({
              selected: i === 0,
              fleet,
              supportTypeName: fleet
                .getSupportTypeNames()
                .map((v) => this.$t(`Result.${v}`))
                .join(' / '),
            });
          }
        }
        if (this.selectableFleets.length > 1) {
          // 有効な艦隊が2つ以上
          this.updateIsMobile();
          this.fleetSelectDialog = true;
          // 一時退避
          this.tempManager = manager;
          return true;
        }

        return this.loadAndOpenFromDeckBuilder(text);
      } catch (error) {
        return false;
      }
    },
    loadAndOpenFromDeckBuilder(builder: string): boolean {
      // デッキビルダー形式データを計算データに設定して計算ページに移譲
      try {
        const { items, ships, cellInfos } = this.$store.state;
        const converter = new Convert(items, ships, this.$store.getters.getEnemies, cellInfos);
        const manager = converter.loadDeckBuilder(builder);
        if (!manager) {
          // 何もない編成データは無意味なので返す
          return false;
        }
        this.expandCalcManager(manager);
        return true;
      } catch (error) {
        return false;
      }
    },
    importSelectedFleet(): void {
      if (!this.selectedAnyFleet) {
        return;
      }
      const manager = this.tempManager;
      if (!manager) {
        return;
      }
      const fleets = this.selectableFleets.filter((v) => v.selected).map((v) => v.fleet);
      // 選択された艦隊で置き換え
      manager.fleetInfo = new FleetInfo({ info: manager.fleetInfo, fleets });
      this.expandCalcManager(manager);
      this.fleetSelectDialog = false;
      this.inform('デッキビルダー形式編成データを読み込みました。');
    },
    expandCalcManager(manager: CalcManager): void {
      let mainData = this.saveData.getMainData();
      if (mainData) {
        const currentManager = mainData.tempData[mainData.tempIndex];
        if (!manager.battleInfo.fleets.some((v) => v.enemies.some((i) => i.data.id > 0))) {
          // 敵情報が空のデータなら元の情報を使う
          manager.battleInfo = currentManager.battleInfo;
        }
        if (!manager.airbaseInfo.airbases.some((v) => v.items.some((i) => i.data.id > 0))) {
          // 基地が空のデータなら元の情報を使う
          manager.airbaseInfo = currentManager.airbaseInfo;
        } else if (currentManager.airbaseInfo.airbases.some((v) => v.mode === AB_MODE.BATTLE)) {
          // 元の基地データのうち出撃情報がある場合、派遣先を流用
          /** 今現在開いているデータの艦隊 */
          const base = currentManager.airbaseInfo.airbases;
          /** デッキビルダーから復元された基地データ */
          const newBase = manager.airbaseInfo.airbases;
          const airbases: Airbase[] = [];
          for (let i = 0; i < base.length; i += 1) {
            const oldBase = base[i];
            if (oldBase.mode === AB_MODE.BATTLE && newBase[i] && newBase[i].mode === AB_MODE.BATTLE) {
              // 派遣先だけ置き換え
              airbases.push(new Airbase({ airbase: newBase[i], battleTarget: oldBase.battleTarget }));
            } else {
              airbases.push(newBase[i]);
            }
          }
          manager.airbaseInfo = new AirbaseInfo({ info: manager.airbaseInfo, airbases });
        }
        if (!manager.fleetInfo.fleets.some((v) => v.ships.some((s) => s.data.id > 0))) {
          // 編成が空のデータなら元の情報を使う
          manager.fleetInfo = currentManager.fleetInfo;
        } else {
          // 元の艦隊をなるべく消したくないのでいろいろやる
          /** 今現在開いているデータの艦隊 */
          const baseFleets = currentManager.fleetInfo.fleets;
          /** デッキビルダーから復元された艦隊データ */
          const newFleets = manager.fleetInfo.fleets;
          for (let i = 0; i < baseFleets.length; i += 1) {
            if (newFleets.length < i + 1) {
              // デッキビルダーは第5艦隊以降はないためおおむねそれを復元するための処理
              newFleets.push(baseFleets[i]);
            }
          }

          // 今開いているデータが連合かどうか
          if (currentManager.fleetInfo.isUnion) {
            manager.fleetInfo = new FleetInfo({ info: manager.fleetInfo, isUnion: true, fleetType: currentManager.fleetInfo.fleetType });
          }
        }

        // 現在位置+1の位置にブッ込む
        if (mainData.tempData[mainData.tempIndex + 1]) {
          mainData.tempData[mainData.tempIndex + 1] = manager;
        } else {
          mainData.tempData.push(manager);
        }
        mainData.tempIndex += 1;
      } else {
        mainData = new SaveData();
        mainData.name = '外部データ';
        mainData.isActive = true;
        mainData.isMain = true;
        mainData.tempData = [manager];
        mainData.tempIndex = 0;
        mainData.tempSavedIndex = 0;
        this.saveData.childItems.push(mainData);
      }
      this.$store.dispatch('setMainSaveData', mainData);
      if (!this.isAirCalcPage) {
        // ページ遷移
        this.$router.push('aircalc');
      }
    },
    setShipStock(data: string): boolean {
      // 在籍艦娘情報を更新
      try {
        const shipList = Convert.readShipStockJson(data);
        if (shipList.length === 0) {
          // 何もない在籍データは無意味なので返す
          return false;
        }
        // 設定書き換え
        if (!this.loading) {
          this.setting.isStockOnlyForShipList = true;
          this.$store.dispatch('updateSetting', this.setting);
        }

        const shipStock = this.$store.state.shipStock as ShipStock[];

        // 旧版かどうかチェック => uniqueIdが仕事しているなら札置き換え判定が出せる (今までは連番を振ってきたので、ユニークidの最大と登録隻数が一致しているかで判定できる)
        if (shipStock.length && shipStock[shipStock.length - 1].uniqueId !== shipStock.length && shipList[shipList.length - 1].uniqueId !== shipList.length) {
          // 札の置き換えが発生しそうか？
          if (shipList.some((w) => shipStock.find((v) => v.uniqueId === w.uniqueId && v.area !== w.area))) {
            // 札が置き換わりそうじゃ。
            this.areaOverwriteConfirmDialog = true;
            this.readyImportShipStock = shipList;
            return true;
          }
        }

        this.$store.dispatch('updateShipStock', shipList);
        return true;
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    overwriteAreaImport() {
      // 上書きして取り込み
      if (this.readyImportShipStock) {
        this.$store.dispatch('updateShipStock', this.readyImportShipStock);
        this.areaOverwriteConfirmDialog = false;
        this.inform('在籍艦娘データの更新が完了しました。');
      }
    },
    importWithoutArea() {
      // 札情報を無視して取り込み
      if (this.readyImportShipStock) {
        const shipStock = this.$store.state.shipStock as ShipStock[];
        for (let i = 0; i < this.readyImportShipStock.length; i += 1) {
          const stock = this.readyImportShipStock[i];
          // 過去の(現在登録されている)札を取得
          const old = shipStock.find((v) => v.uniqueId === stock.uniqueId);
          if (old) {
            stock.area = old.area;
          }
        }
        this.$store.dispatch('updateShipStock', this.readyImportShipStock);
        this.areaOverwriteConfirmDialog = false;
        this.inform('在籍艦娘データの更新が完了しました。');
      }
    },
    setItemStock(data: string): boolean {
      // 所持装備情報を更新
      try {
        const itemList = Convert.readItemStockJson(data);
        if (itemList.length === 0) {
          // 何もない所持装備データは無意味なので返す
          return false;
        }
        // 設定書き換え
        if (!this.loading) {
          this.setting.isStockOnlyForItemList = true;
          this.$store.dispatch('updateSetting', this.setting);
        }
        this.$store.dispatch('updateItemStock', itemList);
        return true;
      } catch (e) {
        console.error(e);
        return false;
      }
    },
    saveCurrentData() {
      // 現在計算画面で開かれているデータを取得
      const data = this.saveData.getMainData();
      if (data) {
        try {
          if (data.isUnsaved) {
            // リネームダイアログを表示
            this.handleSaveAndRenameCurrentData();
            return;
          }
          data.saveManagerData();

          // DB更新を促す
          this.$store.dispatch('updateSaveData', this.saveData);

          this.inform('保存しました。');
        } catch (error) {
          this.inform('保存に失敗しました。', true);
        }
      }
    },
    handleSaveAndRenameCurrentData() {
      // 名前変更ダイアログを展開する
      const data = this.saveData.getMainData();
      if (data) {
        this.editedName = data.name;
        if (data.isUnsaved && data.name === '外部データ') {
          this.editedName = '';
        }
        this.editedRemarks = data.remarks;
        this.isDirectory = data.isDirectory;
        this.selectedColor = data.color;
        if (data.isUnsaved) {
          this.saveDataOrder = 999999;
        } else {
          this.saveDataOrder = data.order + 1;
        }
        this.saveDialogTab = 'save';
        this.disabledUpload = data.isDirectory;
        this.editDialog = true;
      }
    },
    saveAndRenameCurrentData() {
      if (this.isNameEmpty) {
        return;
      }
      this.editDialog = false;

      // 現在計算画面で開かれているデータを取得
      const data = this.saveData.getMainData();
      if (data) {
        try {
          let newData: SaveData;
          if (data.isUnsaved) {
            // 保存されていないファイル群から除去
            this.saveData.childItems = this.saveData.childItems.filter((v) => v !== data);
            newData = data;
          } else {
            newData = new SaveData();
            newData.tempData = [cloneDeep(data.tempData[data.tempIndex])];
            newData.tempIndex = 0;
          }

          newData.name = this.editedName;
          newData.remarks = this.editedRemarks;
          newData.color = this.selectedColor;
          if (this.saveDataOrder) {
            newData.order = this.saveDataOrder;
          }
          this.saveDataOrder = 0;
          newData.editedDate = Date.now();
          newData.isUnsaved = false;
          newData.saveManagerData();

          let folder = this.saveData.childItems.find((v) => v.isDirectory);
          if (folder) {
            // 保存先フォルダを解決 => 複製時 保存元と同じフォルダーにしたい
            const mainData = this.saveData.getMainData();
            if (mainData) {
              const targetFolder = SaveData.getParentFolder(folder, mainData);
              if (targetFolder) {
                folder = targetFolder;
              }
            }

            folder.childItems.push(newData);
            folder.sortChild();

            newData.isActive = true;
            this.saveData.disabledMain();
            newData.isMain = true;

            // DB更新を促す
            this.$store.dispatch('updateSaveData', this.saveData);
            this.$store.dispatch('setMainSaveData', newData);

            this.inform('保存しました。');
          } else {
            throw new Error('「保存されたデータ」フォルダーが見つかりませんでした。');
          }
        } catch (error) {
          this.inform('保存に失敗しました。', true);
        }
      }
    },
    undoClicked() {
      // 元に戻す
      const data = this.mainSaveData;
      if (data) {
        data.tempIndex -= 1;
        this.$store.dispatch('setMainSaveData', data);
      }
    },
    redoClicked() {
      // やり直す
      const data = this.mainSaveData;
      if (data) {
        data.tempIndex += 1;
        this.$store.dispatch('setMainSaveData', data);
      }
    },
    changeSiteTheme(theme: SiteTheme) {
      const isDarkTheme = theme === 'dark' || theme === 'deep-sea';
      this.$vuetify.theme.dark = isDarkTheme;
      this.$vuetify.theme.themes.light.secondary = colors.grey.darken2;

      document.body.classList.remove('deep-sea', 'ice', 'pink', 'green');
      if (theme === 'deep-sea') {
        document.body.classList.add(theme);
      }
      if (theme === 'ice' || theme === 'pink' || theme === 'green') {
        document.body.classList.add(theme);
      }

      this.setting.themeDetail = theme;
      this.updateItemUI();
    },
    changeLocale(local: 'ja' | 'en' | 'cn') {
      this.setting.locale = local;
      this.$i18n.locale = local;
      document.getElementsByTagName('html')[0].lang = local === 'cn' ? 'zh-CN' : local;
      this.$vuetify.lang.current = local;
    },
    toggleItemUIHasBorder() {
      this.setting.itemUI.border = !this.setting.itemUI.border;
      this.updateItemUI();
    },
    toggleItemUIIsBold() {
      this.setting.itemUI.bold = !this.setting.itemUI.bold;
      this.updateItemUI();
    },
    toggleItemUIIsRadius() {
      this.setting.itemUI.radius = !this.setting.itemUI.radius;
      this.updateItemUI();
    },
    updateItemUI() {
      if (!this.setting.itemUI) {
        return;
      }
      // 装備UI設定値を反映
      document.body.classList.remove('item-ui-border', 'item-ui-bold', 'item-ui-radius');
      if (this.setting.itemUI.border) {
        document.body.classList.add('item-ui-border');
      }
      if (this.setting.itemUI.bold) {
        document.body.classList.add('item-ui-bold');
      }
      if (this.setting.itemUI.radius) {
        document.body.classList.add('item-ui-radius');
      }
    },
    closeConfig() {
      this.configDialog = false;
      this.toggleConfigDialog();
    },
    toggleConfigDialog() {
      if (!this.configDialog) {
        // 設定ダイアログを閉じると同時に保存
        // へんなのチェック
        if (this.setting.simulationCount > 100000) {
          this.setting.simulationCount = 100000;
        } else if (this.setting.simulationCount < 100) {
          this.setting.simulationCount = 100;
        }

        if (this.setting.popUpCount > 10000) {
          this.setting.popUpCount = 10000;
        } else if (this.setting.popUpCount < 10) {
          this.setting.popUpCount = 10;
        }

        this.$store.dispatch('updateSetting', this.setting);
      }
    },
    toggleFleetSelectDialog() {
      if (!this.fleetSelectDialog) {
        this.tempManager = undefined;
        // 設定ダイアログを閉じると同時に保存
        this.$store.dispatch('updateSetting', this.setting);
      }
    },
    async clickedShare() {
      await (this.shareDialog = true);
      (this.$refs.shareDialog as InstanceType<typeof ShareDialog>).createdURL = '';
    },
    getUrlParams(value: string) {
      this.urlParameters = {};
      if (!value) return;
      const retVal: { [key: string]: string } = {};
      const array = value.slice(1).split('&');
      for (let i = 0; i < array.length; i += 1) {
        const str = array[i];
        const set = str.split('=');
        retVal[set[0]] = decodeURIComponent(set[1]);
      }
      this.urlParameters = Object.freeze(retVal);
      window.history.replaceState(null, '', `${document.location.pathname}#/`);
    },
    setUrlFragments(value: string) {
      // URLフラグメントより編成、装備、艦隊状況を読み込む
      this.urlFragments = {};
      if (!value) return;
      const sp = value.split('import:');
      if (!sp || sp.length < 2) return;
      this.$router.push({ path: '/' });

      const dataString = decodeURIComponent(sp[1]);
      let json;
      try {
        json = JSON.parse(dataString) as { ships?: unknown; items?: unknown; predeck?: unknown; saveData: unknown };
      } catch (error) {
        // 読み込んだデータが何かおかしい
        console.error(error);
        return;
      }
      try {
        this.urlFragments.saveData = json.saveData ? `${json.saveData}` : '';
      } catch (e) {
        console.error(e);
      }
      try {
        this.urlFragments.predeck = JSON.stringify(json.predeck);
      } catch (e) {
        console.error(e);
      }
      try {
        this.urlFragments.ships = Convert.readShipStockJson(json.ships ? JSON.stringify(json.ships) : '');
      } catch (e) {
        console.error(e);
      }
      try {
        this.urlFragments.items = Convert.readItemStockJson(json.items ? JSON.stringify(json.items) : '');
      } catch (e) {
        console.error(e);
      }
    },
    inform(text: string, isError = false) {
      this.readInformText = text;
      this.readInform = true;
      this.readResultColor = isError ? 'error' : 'success';
    },
    async resetTempData() {
      this.$store.dispatch('updateReadStockId', '');
      this.$store.dispatch('updateTempShipStock', []);
      this.$store.dispatch('updateTempItemStock', []);
      this.$store.dispatch('updateTempDate', '');
      this.inform('閲覧モードを終了しました。');
    },
    changeUploadTabs(value: string) {
      if (value !== 'upload') return;

      const form = this.$refs.uploadSaveDataComp as InstanceType<typeof UploadSaveData>;
      if (form) {
        form.initControl();
      }
    },
    toggleMenuButton() {
      this.setting.visibleAirCalcMenuButton = !this.setting.visibleAirCalcMenuButton;
      this.$store.dispatch('updateSetting', this.setting);
    },
    clickCommentButton() {
      const form = this.$refs.saveDataTab as InstanceType<typeof SaveDataTab>;
      const mainData = this.saveData.getMainData();
      if (form && mainData) {
        form.showNameEditDialog(mainData);
      }
    },
    onResize() {
      this.updateIsMobile();
      if (this.enabledFixDrawer && window.innerWidth < 1480) {
        this.enabledFixDrawer = false;
      } else if (!this.enabledFixDrawer && window.innerWidth >= 1480) {
        this.enabledFixDrawer = true;
      }
    },
    downloadBackupFile() {
      const now = Date.now();
      const backUpData = {
        savedata: this.saveData.getMinifyData(),
        shipStock: ShipStock.createFleetAnalyticsCode(this.$store.state.shipStock as ShipStock[]),
        itemStock: ItemStock.createFleetAnalyticsCode(this.$store.state.itemStock as ItemStock[]),
        outputHistories: this.$store.state.outputHistories,
        quests: this.$store.state.quests,
        ver: 4,
      };
      const minify = LZString.compressToUTF16(JSON.stringify(backUpData));
      const blob = new Blob([minify], { type: 'application/octet-stream' });
      saveAs(blob, `backup_${Convert.formatDate(new Date(), 'yyyyMMdd')}`);
      this.setting.lastBackupCreatedAt = now;
      this.setting.lastBackupPromptAt = now;
      this.$store.dispatch('updateSetting', this.setting);
    },
    async handleFileSelect(file: File) {
      this.backupString = undefined;
      if (!file) {
        return;
      }
      try {
        const minify = await file.text();
        const dataString = LZString.decompressFromUTF16(minify) ?? '{}';
        const data = JSON.parse(dataString);
        if (data.ver === 4 && SaveData.IsSaveData(data.savedata as SaveData) && data.shipStock && data.itemStock && data.outputHistories && data.quests) {
          // 艦隊 装備分析 戦果任務データチェック
          this.backupString = dataString;
        } else if (data.ver === 3 && SaveData.IsSaveData(data.savedata as SaveData) && data.shipStock && data.itemStock && data.outputHistories) {
          // 艦隊 装備分析データチェック
          this.backupString = dataString;
        } else if (data.ver === 2 && SaveData.IsSaveData(data.savedata as SaveData) && data.shipStock && data.itemStock) {
          // 艦隊 装備分析データチェック
          this.backupString = dataString;
        } else if (SaveData.IsSaveData(data as SaveData)) {
          // セーブデータとして復元できるかチェック
          this.backupString = dataString;
        } else {
          throw new Error('復号に失敗');
        }

        this.backupSelectDialog = true;
      } catch (error) {
        console.error(error);
        this.inform('読み込み失敗 -バックアップデータが壊れてるか、なんか違うファイルです。', true);
      }
    },
    cancelBackup() {
      this.backupString = undefined;
      this.backupSelectDialog = false;
      this.fileValue = undefined;
    },
    importBackupData() {
      const str = this.backupString;
      this.backupString = undefined;
      this.backupSelectDialog = false;
      this.fileValue = undefined;

      if (str) {
        if (this.isAirCalcPage) {
          // ページ遷移
          this.$router.push('/');
        }

        const backUpData = JSON.parse(str);
        let saveData: SaveData | undefined;

        if (backUpData.ver >= 2) {
          if (this.isImportSaveData) {
            saveData = SaveData.getInstance(backUpData.savedata as SaveData);
          }
          if (backUpData.shipStock && this.isImportShipData) {
            this.setShipStock(backUpData.shipStock);
          }
          if (backUpData.itemStock && this.isImportItemData) {
            this.setItemStock(backUpData.itemStock);
          }
          if (backUpData.outputHistories && this.isImportURLData) {
            this.$store.dispatch('updateOutputHistories', backUpData.outputHistories);
          }
          if (backUpData.quests) {
            this.$store.dispatch('updateQuests', backUpData.quests);
          }
        } else if (this.isImportSaveData) {
          saveData = SaveData.getInstance(backUpData as SaveData);
        }

        if (saveData) {
          saveData.isReadonly = true;

          for (let i = 0; i < saveData.childItems.length; i += 1) {
            const unsavedData = saveData.childItems[i];
            // ディレクトリ以外は非保存データなので書き換え
            if (!unsavedData.isDirectory) {
              unsavedData.isUnsaved = true;
              unsavedData.isActive = true;
            } else {
              unsavedData.isOpen = true;
              unsavedData.isReadonly = true;
            }
          }

          saveData.sortChild();
          this.$store.dispatch('updateSaveData', saveData);
        }

        if (this.$route.path !== '/') {
          this.$router.push({ path: '/' });
        }

        this.inform('バックアップデータを復元しました。');
      }
    },
    keyupHandler(event: KeyboardEvent) {
      if (this.isAirCalcPage) {
        if (event.ctrlKey && event.code === 'KeyZ' && this.enabledUndo) {
          this.undoClicked();
        } else if (event.ctrlKey && event.code === 'KeyY' && this.enabledRedo) {
          this.redoClicked();
        }
      }
    },
    keydownHandler(event: KeyboardEvent) {
      if (this.isAirCalcPage && event.ctrlKey && event.code === 'KeyS') {
        this.saveCurrentData();
        event.preventDefault();
      }
    },
    scrollTop() {
      window.scroll({ top: 0, behavior: 'smooth' });
    },
  },
  beforeDestroy() {
    if (this.unsubscribe) {
      (this.unsubscribe as () => void)();
    }
  },
  destroyed() {
    document.removeEventListener('keyup', this.keyupHandler);
    document.removeEventListener('keydown', this.keydownHandler);
  },
  errorCaptured(error) {
    const message = error.toString();
    console.error(message);
    // window.location.reload();
    return false;
  },
});
